import React from "react";
import { Tabs, Tab } from "react-bootstrap";
import "./style.scss";

interface FoodFormTabsProps {
    defaultActiveKey?: string;
    activeKey: string;
    onChange: (key: string) => void;
    tabs: {
        eventKey: string;
        title: string;
        tabClassName?: string;
    }[];
}

const GeneralTab: React.FC<FoodFormTabsProps> = ({
    onChange,
    activeKey,
    tabs,
    defaultActiveKey = "1",
}) => {
    return (
        <div className="tabs-container ml-auto">
            <Tabs
                key={activeKey}
                onSelect={(value) => {
                    onChange(value as string);
                }}
                defaultActiveKey={defaultActiveKey}
                activeKey={activeKey}
            >
                {tabs.map((tab) => (
                    <Tab
                        key={tab.eventKey}
                        tabClassName={tab.tabClassName}
                        eventKey={tab.eventKey}
                        title={tab.title}
                    />
                ))}
            </Tabs>
        </div>
    );
};

export default GeneralTab;
